import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const TermsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7023">
      <Navbar scrolled={scrolled} data-id="element-7024" />
      <main className="pt-24 pb-20" data-id="element-7025">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7026">
          <div className="max-w-4xl mx-auto" data-id="element-7027">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7028">
              Terms of Service
            </h1>
            <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-7029">
              Last updated: March 16, 2026
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-7030" />
    </div>;
};